import React, { useContext } from 'react';
import { AppContext } from "../../util/AppContext";
import { getConfigValue } from "../../util/getConfigValue";
import { getTimePeriodLabel } from '../UtilizationReportingDashboard/charts/utlizationChart';
import PropType from 'prop-types';

SignedInUsersCard.propTypes = {
    userStats: PropType.object,
    isLoading: PropType.bool,
    filterState: PropType.object
};
function SignedInUsersCard({ userStats, isLoading, filterState }) {
    const [appState] = useContext(AppContext);
    const cardEnabled = getConfigValue(appState?.config?.Leaderboard?.Charts?.SignedInUsers?.Enabled, appState)?.Value === 'true' || false;
  
    return (
        <>
            {cardEnabled &&
                <div className="card pd-card p-4 chartCardContainer mt-5">
                    <div className="row justify-content-center">
                        {isLoading ? (
                            <div className="col-1 col-md-1 mb-0 mb-md-0">
                                <p>{getConfigValue(appState.config.Common?.Loading, appState)?.Value}</p>
                            </div>
                        ) : (
                            <>
                               <div className="col-12 col-md-4 d-flex flex-column align-items-center">
                                    <div className="type-24 fw-bold color-grey-l3">{getConfigValue(appState?.config?.Leaderboard?.SignedInUsersCard?.Title, appState)?.Value || "Your Stats for:"}</div>
                                    <div className="type-20 fw-bold color-grey-l3">{getTimePeriodLabel(filterState?.timePeriodId)}</div>
                                </div>
                                <div className="col-12 col-md-4 d-flex align-items-center">
                                    <span className="label">{getConfigValue(
                                        appState?.config?.Leaderboard?.SignedInUsersCard?.TotalPdfsGenerated?.Label,
                                        appState
                                    )?.Value || "Most PDFs Generated"}</span>
                                    <span className="count">{userStats?.totalPdfCount}</span>
                                </div>
                                <div className="col-12 col-md-4 d-flex align-items-center">
                                    <span className="label">{getConfigValue(
                                        appState?.config?.Leaderboard?.SignedInUsersCard?.TotalLogins?.Label,
                                        appState
                                    )?.Value || "Total Logins"}</span>
                                    <span className="count">{userStats?.totalLoginCount}</span>
                                </div>                                
                            </>
                        )}
                    </div>
                </div>
            }
        </>
    );
}

export default SignedInUsersCard;
